import React from 'react';

import {assert} from 'Asserts';
import getTestProps from 'test/lib/cypress/getTestProps';
import APIUtil from 'util/APIUtil';

import ContainerRelevantItemsSection from './ContainerRelevantItemsSection';

interface Props {
  containerId: string;
}

export default function ContainerRelevantItemsView(props: Props): JSX.Element {
  assert(APIUtil.isContainer(props.containerId), 'Expected a container ID');

  return (
    <div
      className="react-tab-container"
      {...getTestProps({component: 'ContainerRelevantItemsView', element: 'root'})}
    >
      <ContainerRelevantItemsSection containerId={props.containerId} />
    </div>
  );
}
